import * as React from 'react';
import type { TransportRoute } from 'contracts/transport-routes';
import { Card, CardContent } from 'components/ui/card';
import { Separator } from 'components/ui/separator';
import { Loading } from 'styles/styled-components';
import { cn } from 'lib/utils';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  transportRouteId: string;
  transportRoute?: TransportRoute;
  loading?: boolean;
}

export const PageHeader = ({
                             transportRouteId,
                             transportRoute,
                             loading,
                             className,
                             ...props
                           }: Props) => {

  return (
    <Card {...props} className={cn('', className)}>
      <CardContent className={'py-4 flex flex-row items-center gap-4 text-gray-800'}>
        <h2 className={'font-GilroySemibold'}>ID {transportRouteId.padStart(4, '0')}</h2>
        {transportRoute?.name && (
          <>
            <Separator className={'border-gray-400 border h-4'} orientation={'vertical'} />
            <h2 className={'font-GilroySemibold'}>{transportRoute.name}</h2>
          </>
        )}
        {loading && <Loading />}
      </CardContent>
    </Card>
  );
};